import Files from '../components/Files/Files';

function FilesPage() {
  return (
    <div className="h-screen">
      <Files />
    </div>
  );
}

export default FilesPage;
